import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationGaugePressure,
    CalibrationPressureUnit
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import Bold from 'components/Bold';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { formatPressureUnit } from 'services/equipmentSets/utils';

import { makeSelectCalibrationValue } from '../../selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    pressure: CalibrationGaugePressure;
    pressureUnit: CalibrationPressureUnit;
}

type Props = OwnProps & ConnectedProps;

export class PressureTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pressure, pressureUnit } = this.props;
        const formattedPressureUnit = formatPressureUnit(pressureUnit);

        return (
            <TableCell>
                <Bold>
                    {pressure}
                    {formattedPressureUnit && ` ${formattedPressureUnit}`}
                </Bold>
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    pressure: makeSelectCalibrationValue('gaugePressure'),
    pressureUnit: makeSelectCalibrationValue('pressureUnit')
});

export default connect(mapStateToProps)(PressureTableCellComponent);
